export enum ObjectType {
    WhitePlate = 1,
    YellowPlate = 2,
    Motorcycle = 3,
    Camping = 4,
    Boat = 5,
    BoatAccessories = 16,
    ParrotPlates = 20,
}